import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class DeletePaymentsService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

   /**
     * Get deletable radiation payments
     * @returns Array
     */
    fetchRadiationPayments(): Observable<ApiResponse>{

      let apiURL:string=`${this.baseURL}/v1/transactions/radiation-payments/deletable-list`;

      return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Delete radiation payment
     * @param row_id
     * @param vehicle_id
     */
    deleteRadiationPayment(row_id:number,vehicle_id: string, chassis_no: string, amount:number){

      let apiURL:string=`${this.baseURL}/v1/transactions/radiation-payments/delete/${row_id}/${vehicle_id}/${chassis_no}/${amount}`;

      return this.http.delete<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
    }

     /**
     * Get deletable IDF payments
     * @returns Array
     */
     fetchIDF_Payments(): Observable<ApiResponse>{

      let apiURL:string=`${this.baseURL}/v1/transactions/idf-payments/deletable-list`;

      return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Delete IDF payment
     * @param row_id
     * @param vehicle_id
     */
    deleteIDF_Payment(row_id:number,vehicle_id: string, chassis_no: string, amount:number){

      let apiURL:string=`${this.baseURL}/v1/transactions/idf-payments/delete/${row_id}/${vehicle_id}/${chassis_no}/${amount}`;

      return this.http.delete<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Get deletable NEMA payments
     * @returns Array
     */
    fetchNEMA_Payments(): Observable<ApiResponse>{

      let apiURL:string=`${this.baseURL}/v1/transactions/nema-payments/deletable-list`;

      return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Delete NEMA payment
     * @param row_id
     * @param vehicle_id
     */
    deleteNEMA_Payment(row_id:number,vehicle_id: string, chassis_no: string, amount:number){

      let apiURL:string=`${this.baseURL}/v1/transactions/nema-payments/delete/${row_id}/${vehicle_id}/${chassis_no}/${amount}`;

      return this.http.delete<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
    }
}
